// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import type { TaskList } from '../../../common/types.tsx';
import type { State, ProjectState } from '../../model/types.tsx';
import { getAllTasks } from '../../tasks/index.tsx';
import { nextOpenTask } from '../next-open-task/index.tsx';

type NextGetTasksProps = {
	shouldShowScrumOnboardingExperience: boolean;
	canCreateProject: boolean;
	routeName: string;
	projectState: ProjectState | null;
	taskGroupParent: string;
	mountedNudges: string[];
	isCrossProjectBoardToPlanUpsell: boolean;
	// can edit any plans
	canEditPlans: boolean;
	premiumTrialOnSignup: boolean | undefined;
	taskList?: TaskList;
	isEligibleForTailoredOnboardingM2P5?: boolean;
	isEligibleForTailoredOnboardingM3?: boolean;
	isEligibleForTailoredOnboardingScrumAndSoftwareKanban?: boolean;
	teamType?: string;
	features: {
		hasBacklog?: boolean;
		hasSprint?: boolean;
		hasSummaryPage?: boolean;
		hasRoadmap?: boolean;
		hasList?: boolean;
		hasCalendar?: boolean;
		hasCode?: boolean;
		hasForms?: boolean;
		hasPages?: boolean;
		hasPlanDependencies?: boolean;
	};
	// default value is 'project'
	containerType?: 'project' | 'plan';
};

export const nextGetTasks =
	(props: NextGetTasksProps): Action<State> =>
	({ getState, setState, dispatch }) => {
		const { taskList, completedTaskList, openTask, isQuickstartLoaded } = getState();
		const tasks = getAllTasks({ ...props, taskList });
		setState({ tasks });

		// Auto-open the first incomplete task if no task is currently open
		// Note: nextGetTasks and refreshAppState can in theory happen in any order
		// Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
		// This ensures backend state has been restored before we auto-open
		if (
			tasks?.items &&
			tasks.items.length > 0 &&
			isQuickstartLoaded &&
			fg('jira-fix-qs-first-card-opening-on-land')
		) {
			const firstIncompleteTask = tasks.items.find((taskId) => !completedTaskList.includes(taskId));

			// If we found a first incomplete task and no task is currently open, open it
			if (firstIncompleteTask && !openTask) {
				dispatch(nextOpenTask(firstIncompleteTask));
			}
		}
	};
